<template>
  <div>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
          <van-image
            fit="contain"
            :src="require('@/assets/images/index/u111.png')"
          />
      </van-swipe-item>
      <van-swipe-item>
          <van-image
            fit="contain"
            :src="require('@/assets/images/index/u116.png')"
          />
      </van-swipe-item>
      <van-swipe-item>
          <van-image
            fit="contain"
            :src="require('@/assets/images/index/u121.png')"
          />
      </van-swipe-item>
    </van-swipe>

    <div class="ctentstwo">
        <div>
          <van-grid :column-num="3" class="cardcont" :border="false">
          <van-grid-item  @click="Remtof">
              <img src="@/assets/images/index/u127.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('yckm')}}</p>
          </van-grid-item>
          <van-grid-item  @click="Homemake" v-if="Userof.person_type !=1">
              <img src="@/assets/images/index/u101.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('fkyy')}}</p>
          </van-grid-item>
          <van-grid-item  @click="Homekey" v-if="Userof.person_type !=1">
              <img src="@/assets/images/index/u106.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('fxys')}}</p>
          </van-grid-item>
          <van-grid-item  @click="Homeqr">
              <img src="@/assets/images/index/u86.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('ewmkm')}}</p>
          </van-grid-item>
          <van-grid-item @click="scanQRCode">
              <img src="@/assets/images/index/u91.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('smkm')}}</p>
          </van-grid-item>
          <van-grid-item @click="Homeble" >
              <img src="@/assets/images/index/u96.png" alt="" >
              <p style="margin: 10px 0;color:#7F7F7F">{{this.$t('yjkm')}}</p>
          </van-grid-item>
        </van-grid>
        </div>
    </div>

    <!-- <div>
      {{ ceshi }}
      <div>用户id：{{ userId }}</div>
    </div> -->

    
  <Footer :active="active" :person_type="Userof.person_type"></Footer>

  <!-- 弹出窗 -->

    <van-dialog v-model="showst" :show-cancel-button="true" confirm-button-color="#48C9B0" :title="$t('xgmm')"  @confirm="onSubmit">
     <div class="fomes">
       <van-form  class="fromctent">
                <!-- <van-field
                v-model="name"
                :placeholder="$t('yhm')"
                :border="true"
                
                clearable
                size='large'
                /> -->
                <van-field
                    v-model="mobile"
                    :placeholder="$t('sjhm')"
                    :border="true"
                    clearable
                    size='large'
                    />
                <van-field
                v-model="old_password"
                :placeholder="$t('jmm')"
                :border="true"
                clearable
                size='large'
                />
                <van-field
                v-model="password"
                type="password"
                :placeholder="$t('xmm')"
                :border="true"
                clearable
                size='large'
                />
            </van-form>
     </div>

    </van-dialog>
    
  </div>
</template>
<script>
import { Dialog, Toast } from 'vant';
import { translateQRcode } from '@/utils/index.js'
import axios from 'axios'
import qs from 'qs'
import QrScanner from 'qr-scanner'
QrScanner.WORKER_PATH = '/qr-scanner-worker.min.js'

export default {
  components: {},
  data(){
    return{
      showst:false,
      mobile:'',
      password:'',
      old_password:'',

      active: 0,

      Userof:JSON.parse(window.localStorage.getItem('getTokendata')),
      equipmentlist:null,
      datetrans:null,
      address:localStorage.getItem("address")?localStorage.getItem:'+86',

      ceshi:'11',
      userId:''
    }
  },
  mounted(){
    
    this.onShowst()
    this.getequipment()
    
  },
  methods:{
    onShowst(){
      if(this.Userof.password == '21218cca77804d2ba1922c33e0151105'){
        this.showst = true
      }else{
        this.showst = false
      }
    },
    onSubmit(){
      let mobiles =this.address+'-'+ this.mobile
        let data={
            method:"co.wx.pwd.modify",
            // name:this.name,
            mobile:mobiles,
            old_password:this.$md5(this.old_password),
            password:this.$md5(this.password)
        }
        this.$serve(data).then(res=>{
            if(res.data.code==0){
                Toast.success(this.$t('szcg'));
                window.localStorage.removeItem('getTokendata')
                this.$router.push({ path: '/login' })
            }else{
                Toast.fail(this.$t('szsb'));
            }
        })
    },
    Remtof(){
      this.$router.push({ path: '/Homerote' })
    },
    //访客预约
    Homemake(){
      this.$router.push({ path: '/Homemake' })
    },
    // 分享钥匙
    Homekey(){
      this.$router.push({ path: '/Homekey' })
    },
    // 二维码开门
    Homeqr(){
      this.$router.push({ path: '/Homeqr' })
    },
    // 蓝牙
    Homeble(){
      this.$router.push({ path: '/Homeble' })
    },
    //远程设备列表

    getequipment(){
      let data={
        method:'co.wx.remote.device.list',
        user_id:this.Userof.user_id,
        page_index:1,
        page_size:10,
        keyword:''
      }
      this.$serve(data).then(res=>{
        if(res.data.code==0){
          this.equipmentlist = res.data.data
          console.log(this.equipmentlist)
        }
        
      })
    },

    // 扫码功能
    scanQRCode() {
      // 检查浏览器是否支持摄像头
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        Toast.fail('您的浏览器不支持摄像头');
        return;
      }

      const that = this;
      let scanner = null;
      let stream = null;
      let scanContainer = null;

      // 创建扫码界面
      function createScanUI() {
        scanContainer = document.createElement('div');
        scanContainer.style.position = 'fixed';
        scanContainer.style.top = '0';
        scanContainer.style.left = '0';
        scanContainer.style.width = '100%';
        scanContainer.style.height = '100%';
        scanContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
        scanContainer.style.zIndex = '9999';
        scanContainer.style.display = 'flex';
        scanContainer.style.flexDirection = 'column';
        scanContainer.style.alignItems = 'center';
        scanContainer.style.justifyContent = 'center';

        // 添加返回按钮
        const backButton = document.createElement('button');
        backButton.innerText = that.$t('返回');
        backButton.style.position = 'absolute';
        backButton.style.top = '20px';
        backButton.style.left = '20px';
        backButton.style.padding = '10px 20px';
        backButton.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
        backButton.style.color = 'white';
        backButton.style.border = 'none';
        backButton.style.borderRadius = '5px';
        backButton.style.fontSize = '16px';
        backButton.onclick = () => {
          stopScanner();
          if (scanContainer && document.body.contains(scanContainer)) {
            document.body.removeChild(scanContainer);
          }
        };
        scanContainer.appendChild(backButton);

        // 添加视频元素
        const video = document.createElement('video');
        video.id = 'scan-video';
        video.style.width = '80%';
        video.style.maxWidth = '400px';
        video.style.height = 'auto';
        video.setAttribute('autoplay', 'true');
        video.setAttribute('muted', 'true');
        video.setAttribute('playsinline', 'true');
        scanContainer.appendChild(video);

        // 添加提示文字
        const hintText = document.createElement('div');
        hintText.innerText = that.$t('请将二维码对准摄像头');
        hintText.style.color = 'white';
        hintText.style.marginTop = '20px';
        hintText.style.fontSize = '16px';
        scanContainer.appendChild(hintText);

        document.body.appendChild(scanContainer);
        return video;
      }

      // 检查权限状态
      async function checkPermissionStatus() {
        try {
          const result = await navigator.permissions.query({ name: 'camera' });
          return result.state;
        } catch (error) {
          console.log('权限API不可用，将尝试直接获取摄像头');
          return 'prompt'; // 默认假设可以请求权限
        }
      }

      // 请求摄像头权限并开始扫描
      async function startScanner() {
        const video = createScanUI();

        try {
          // 获取摄像头流
          stream = await navigator.mediaDevices.getUserMedia({ 
            video: { 
              facingMode: 'environment',
              width: { ideal: 1280 },
              height: { ideal: 720 }
            } 
          });
          video.srcObject = stream;

          // 创建 QR 扫描器
          scanner = new QrScanner(video, (result) => {
            console.log('扫码成功:', result);
            stopScanner();
            if (scanContainer && document.body.contains(scanContainer)) {
              document.body.removeChild(scanContainer);
            }
            that.navigateToScanResult(result.data);
          }, {
            onDecodeError: (error) => {
              // 解码错误，通常是因为没有对准二维码，这是正常现象，不需要输出日志
            },
            highlightScanRegion: true,
            highlightCodeOutline: true
          });

          // 开始扫描
          scanner.start();
          console.log('扫码开始');
        } catch (error) {
          console.error('无法访问摄像头:', error);
          stopScanner();
          if (scanContainer && document.body.contains(scanContainer)) {
            document.body.removeChild(scanContainer);
          }

          // 根据错误类型提供不同的提示
          if (error.name === 'NotAllowedError') {
            // 权限被拒绝
            that.showPermissionDeniedDialog();
          } else if (error.name === 'NotFoundError') {
            Toast.fail('未检测到摄像头设备');
          } else if (error.name === 'NotReadableError') {
            Toast.fail('摄像头被其他应用占用');
          } else {
            Toast.fail('无法访问摄像头: ' + error.message);
          }
        }
      }

      function stopScanner() {
        if (scanner) {
          scanner.stop();
          scanner.destroy();
          scanner = null;
        }
        if (stream) {
          stream.getTracks().forEach(track => track.stop());
          stream = null;
        }
      }

      // 检查权限后开始
      checkPermissionStatus().then(status => {
        if (status === 'denied') {
          // 权限已被拒绝，显示提示对话框
          that.showPermissionDeniedDialog();
        } else {
          // 权限可用或需要请求，直接开始扫描
          startScanner();
        }
      }).catch(() => {
        // 权限检查失败，直接尝试扫描
        startScanner();
      });
    },

    // 显示权限被拒绝的提示对话框
    showPermissionDeniedDialog() {
      Dialog({
        title: this.$t('摄像头权限被拒绝'),
        message: this.$t('请在浏览器设置中开启摄像头权限'),
        confirmButtonText: this.$t('知道了'),
        confirmButtonColor: '#48C9B0'
      }).then(() => {
        // 用户点击确认后，可以引导用户去设置权限
      }).catch(() => {
        // 用户取消
      });
    },

    // 处理扫码结果
    navigateToScanResult(result) {
      console.log(`999909`, result);
      this.ceshi = result
      this.datetrans = translateQRcode(result, false);
      console.log(this.datetrans);

      let pamast = {
        method: 'co.wx.remote.device.get',
        signature: '',
        user_id: this.Userof.user_id,
        device_no: this.datetrans[0],
        platform: 'weixin2'
      };

      this.$serve(pamast).then(res => {
        console.log(`9909`, res);
        
        if (res.data.code == 0) {
          let data = {
            method: 'mqtt.door.open',
            userId: this.Userof.user_id,
            serial: res.data.data.serial,
            password: res.data.data.password,
            platform: 'weixin2'
          };
          data = qs.stringify(data);
          axios.post('https://web.fondcard.net/open/mqtt/api.php?method=mqtt.door.open', data).then(res => {
            if (res.data.code == 0) {
              Toast.success(this.$t('kmcg'));
            } else {
              Toast.fail(this.$t('kmsb'));
            }
          });
        } else {
          Toast.fail(this.$t('sbbczhmqx'));
        }
      });
    },
  }

}
</script>

<style scoped>
  .my-swipe img{
    width: 100%;
    height: 360px;
  }
  .ctentstwo{
    display: flex;
  }
  .imgs{
    display: flex;
    flex: 1;
    justify-items: center;
    align-items: center;
  }
  .imgs img{
    width: 22px;
    height: 38px;
    margin-right: 5px;
    margin-top: 15px;
  }
  .cardcont{
    flex: 20;
    margin-top: 35px;
  }
  .cardcont img{
    width: 90px;
  } 
  .cardcont >>> .van-grid-item__content{
    padding: 10px 4px;
  }
  .fomes{
    padding: 0px 20px 30px 20px;
  }
  .fromctent{
    width: 88%;
    margin: 0 auto;
    margin-top:30px;
}
.fromctent >>>.van-field__left-icon .van-icon-friends{
    font-size: 26px;
    margin-left: -5px;
    color: #CCCCCC;
}
.fromctent >>>.van-cell--large{
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    padding: 8px;
    margin-bottom: 10px;
}
.fromctent >>>.van-cell--center{
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    padding: 4px;
}
.fromctent >>>.van-field__left-icon .van-icon-bag{
    font-size: 28px;
    /* margin-left: 2px; */
    color: #CCCCCC;
}

</style>